import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet"; // ⬅️ Ajouté
import AboutUs from "../../sections/AboutUs/AboutUs";
import IntroBanner from "../../sections/IntroBanner/IntroBanner";
import "./Accueil.css";
import Services from "../../sections/Services/Services";
import Wave from "../../components/Wave/Wave";
import TrustIndexWidget from "../../sections/TrustIndexWidget/TrustIndexWidget";
import Contact from "../../sections/Contact/Contact";

const Accueil = () => {
  const [darkMode, setDarkMode] = useState(
    () =>
      localStorage.getItem("darkMode") === "true" ||
      window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (e) => {
      setDarkMode(e.matches);
      localStorage.setItem("darkMode", e.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Pokélu - Éducatrice comportementaliste et garde d'élevage pour chiens et chats.
        </title>
        <meta
          name="description"
          content="Vous recherchez une spécialiste du comportement canin et félin ou une remplaçante de confiance ? Ne cherchez plus, vous êtes à la bonne adresse ! Avec Pokélu, offrez à votre compagnon une éducation bienveillante et partez en toute sérénité."
        />
      </Helmet>

      <IntroBanner />
      <AboutUs />
      <Wave isStart={true} isCanva={true} />
      <Services />

      <div className="video-container">
        <video className="full-width-video" autoPlay loop muted>
          <source
            src={
              darkMode
                ? "./video/pokelu-video-dark.mp4"
                : "./video/pokelu-video.mp4"
            }
            type="video/mp4"
          />
          Votre navigateur ne supporte pas la vidéo.
        </video>
        <Wave isStart={false} isCanva={true} />
      </div>

      {/* <TrustIndexWidget /> */}
      <Contact />
    </>
  );
};

export default Accueil;
